import React from 'react'
import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function YourReporting() {


const nav = useNavigate()



    const [data , setdata ] = useState([])


    useEffect(() => {
        const agencyid = localStorage.getItem('Agencyid');
        if (agencyid) {

            geturreportings(agencyid)
        }
      }, []);
    


async function geturreportings(agencyid){



  


    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/reportedbyme', {
      method: 'POST',
      body: JSON.stringify({ agencyid}),
      headers: { 'Content-Type': 'application/json' },
    });
    const post = await res.json();

    setdata(post)

    



}





async function Deletereporting(objid){



  


  const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/deletereporting', {
    method: 'POST',
    body: JSON.stringify({objid}),
    headers: { 'Content-Type': 'application/json' },
  });
  const post = await res.json();

  
   nav('/reportdisaster')


}






  return (
  <>

  
  {data.length>0?<>
    <div className="earthquake-info-container">
  {data.map((a) => (
    <div key={a._id} className="earthquake-info-box3 cursor-pointer">
      <br />
<button className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-2 rounded ml-4 text-xs w-36"   onClick={()=>Deletereporting(a._id)}>
  Withdraw Reporting
</button>
<br />
<br />
      <div className="info-item">
        <p className="info-label">Agency ID:</p>
        <p className="info-data">{a.agencyId}</p>
      </div>

      <div className="info-item">
        <p className="info-label">City:</p>
        <p className="info-data">{a.city}</p>
      </div>

      <div className="info-item">
        <p className="info-label">Disaster Type:</p>
        <p className="info-data">{a.disastertype}</p>
      </div>

      <div className="info-item">
        <p className="info-label">Severity:</p>
        <p className="info-data">{a.severity}</p>
      </div>

      <div className="info-item">
        <p className="info-label">Description:</p>
        <p className="info-data">{a.description}</p>
   
      </div>


  

<br />
    </div>
  ))}
</div>


  
  
  
  </>:<>
  <h1>You have not reported yet</h1>

  
  </>
  
  
  
  }
  
  
  
  </>
  )
}
